module.exports = __webpack_public_path__ + "static/media/error_triangle.66a6d1eb.svg";